import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import Home from "@/pages/Home";
import CaseStudy from "@/pages/CaseStudy";
import PortfolioPage from "@/pages/Portfolio";
import FounderPage from "@/pages/Founder";
import AdminLogin from "@/pages/AdminLogin";
import AdminForgot from "@/pages/AdminForgot";
import AdminReset from "@/pages/AdminReset";
import AdminDashboard from "@/pages/AdminDashboard";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import ProtectedRoute from "@/components/ProtectedRoute";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <div className="grain-overlay" />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/portfolio" element={<PortfolioPage />} />
            <Route path="/founder" element={<FounderPage />} />
            <Route path="/work/:slug" element={<CaseStudy />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/forgot" element={<AdminForgot />} />
            <Route path="/admin/reset" element={<AdminReset />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
          </Routes>
          <Toaster position="bottom-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
